import React, { useState } from 'react';
import { UserCircle, Tag, BarChart3, Shield, XCircle, Sparkles } from 'lucide-react';
interface RightSideNavBarProps {
  toggleRiskPanel: () => void;
  showRiskPanel: boolean;
  toggleAIChat: (autoMessage?: boolean) => void;
  showAIChat: boolean;
}
export const RightSideNavBar = ({
  toggleRiskPanel,
  showRiskPanel,
  toggleAIChat,
  showAIChat
}: RightSideNavBarProps) => {
  const handleToggleAIChat = () => {
    toggleAIChat(false); // No auto message when clicking icon
    if (showRiskPanel) {
      toggleRiskPanel();
    }
  };
  const handleToggleRiskPanel = () => {
    toggleRiskPanel();
    if (showAIChat) {
      toggleAIChat(false);
    }
  };
  return <div className="w-20 bg-white flex flex-col items-center py-6" data-id="element-402">
      <div className="flex flex-col items-center gap-3" data-id="element-403">
        <NavIcon icon={<Sparkles size={24} data-id="element-405" />} isAIChat={true} active={showAIChat} onClick={handleToggleAIChat} title="AI Assistant" data-id="element-404" />
        <NavIcon icon={<UserCircle size={24} data-id="element-407" />} data-id="element-406" />
        <NavIcon icon={<Tag size={24} data-id="element-409" />} data-id="element-408" />
        <NavIcon icon={<BarChart3 size={24} data-id="element-411" />} data-id="element-410" />
        <NavIcon icon={<XCircle size={24} data-id="element-413" />} data-id="element-412" />
        <NavIcon icon={<Shield size={24} data-id="element-415" />} active={showRiskPanel} onClick={handleToggleRiskPanel} isRiskPanel={true} title="Risk Assessment" data-id="element-414" />
      </div>
    </div>;
};
const NavIcon = ({
  icon,
  active = false,
  onClick,
  isRiskPanel = false,
  isAIChat = false,
  title = 'Disabled'
}: {
  icon: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
  isRiskPanel?: boolean;
  isAIChat?: boolean;
  title?: string;
}) => {
  return <div className={`w-12 h-12 flex items-center justify-center rounded-full 
      ${active ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white ring-2 ring-black' : isRiskPanel || isAIChat ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white' : 'bg-gray-100 text-gray-700'} 
      cursor-pointer hover:bg-gray-200 transition-colors`} onClick={onClick} title={title} data-id="element-416">
      {icon}
    </div>;
};